import {
  Switch,
} from 'react-router-dom';
import { Coupon } from './features/question/Coupon';

export function AppCouponMain(props: {
}): JSX.Element {

  return (
    <Switch>
      <Coupon />
    </Switch>
  )
}
